function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useCallback, useMemo, useEffect, useContext } from 'react';
import { useSelector, useStore } from 'react-redux';
import { getMutationSelector, resetRequests, addWatcher, removeWatcher, joinRequest } from '@redux-requests/core';
import useDispatchRequest from './use-dispatch-request';
import RequestsContext from './requests-context';
var emptyVariables = [];

var useMutation = function useMutation(_ref) {
  var _ref$variables = _ref.variables,
      variables = _ref$variables === void 0 ? emptyVariables : _ref$variables,
      autoReset = _ref.autoReset,
      throwError = _ref.throwError,
      suspense = _ref.suspense,
      selectorProps = _objectWithoutPropertiesLoose(_ref, ["variables", "autoReset", "throwError", "suspense"]);

  var requestContext = useContext(RequestsContext);
  suspense = suspense === undefined ? requestContext.suspense : suspense;
  autoReset = autoReset === undefined ? requestContext.autoReset : autoReset;
  throwError = throwError === undefined ? requestContext.throwError : throwError;
  var dispatchRequest = useDispatchRequest();
  var store = useStore();
  var key = "" + selectorProps.type + (selectorProps.requestKey || '');
  var dispatchMutation = useCallback(function () {
    return dispatchRequest((selectorProps.action || selectorProps.type).apply(void 0, variables));
  }, [selectorProps.action, selectorProps.type].concat(variables));
  var mutation = useSelector(getMutationSelector(selectorProps));
  useEffect(function () {
    dispatchRequest(addWatcher(key));
    return function () {
      dispatchRequest(removeWatcher(key));

      if (autoReset && !store.getState().requests.watchers[key]) {
        dispatchRequest(resetRequests([{
          requestType: selectorProps.type,
          requestKey: selectorProps.requestKey
        }], false));
      }
    };
  }, [selectorProps.type, selectorProps.requestKey]);

  if (suspense && mutation.loading) {
    throw dispatchRequest(joinRequest(key));
  }

  if (throwError && mutation.error) {
    throw {
      error: mutation.error,
      type: selectorProps.type,
      requestKey: selectorProps.requestKey
    };
  }

  return useMemo(function () {
    return _extends({}, mutation, {
      mutate: dispatchMutation
    });
  }, [mutation, dispatchMutation]);
};

export default useMutation;